import React from 'react';

interface DashboardIconProps {
    className?: string;
}

const DashboardIcon: React.FC<DashboardIconProps> = ({ className = "w-5 h-5" }) => (
    <svg className={className} fill="currentColor" viewBox="0 0 20 20">
<path d="M5.42857 14.5714H7.14286V10H5.42857V14.5714ZM12.8571 14.5714H14.5714V5.42857H12.8571V14.5714ZM9.14286 14.5714H10.8571V11.1429H9.14286V14.5714ZM9.14286 10H10.8571V8.28571H9.14286V10ZM3.71429 18C3.24286 18 2.83929 17.8321 2.50357 17.4964C2.16786 17.1607 2 16.7571 2 16.2857V3.71429C2 3.24286 2.16786 2.83929 2.50357 2.50357C2.83929 2.16786 3.24286 2 3.71429 2H16.2857C16.7571 2 17.1607 2.16786 17.4964 2.50357C17.8321 2.83929 18 3.24286 18 3.71429V16.2857C18 16.7571 17.8321 17.1607 17.4964 17.4964C17.1607 17.8321 16.7571 18 16.2857 18H3.71429ZM3.71429 16.2857H16.2857V3.71429H3.71429V16.2857Z" fill="#6D707B"/>
</svg>

);

export default DashboardIcon;
